var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"100%"},on:{"click":_vm.pause}},[_c('vue-aliplayer-v2',_vm._g(_vm._b({ref:"VueAliplayerV2",style:("height: 100%")},'vue-aliplayer-v2',_vm.$attrs,false),_vm.$listeners))],1)}
var staticRenderFns = []

export { render, staticRenderFns }